// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__contentBox--ayMzs {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid rgba(125, 130, 135, 0.15);
  padding: 16px;
}
.style__contentBoxTitle--pRFJf {
  font-weight: 700;
  font-style: normal;
}
.style__licenseChangeHint--JL57S {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.75rem;
  margin: 0 0 1rem 0;
  padding: 0.75rem 1rem;
  background-color: #e5f9ff;
  border: 1px solid #b3ecff;
  border-radius: 6px;
  font-size: 0.8125rem;
  color: #0e7098;
  line-height: 1.4;
}
.style__licenseChangeHintIcon--9aUhJ {
  color: #1287b8;
  flex-shrink: 0;
  margin-top: 1px;
}
.style__row--y_Wbb {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  width: 100%;
  align-items: center;
  padding: 1rem;
}
.style__licenseInfo--CzpcN {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}
.style__licenseCode--sfMwC {
  font-weight: 600;
}
.style__licenseMeta--LsWGh {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  color: #7d8287;
  font-size: 0.8125rem;
  flex-wrap: wrap;
}
.style__licenseSeparator--fcoel {
  color: #afb2b6;
  font-size: 0.75rem;
  user-select: none;
}
.style__badgeWrapper--oFMl8 {
  flex-basis: 10%;
}
.style__editButtonWrapper--GJq18 {
  flex-basis: 20%;
  display: flex;
  flex-direction: row;
}
.style__editButtonWrapper--GJq18 * {
  margin: 0 2px;
}
.style__classDivider--QCIiF {
  margin: 0;
}
.style__cancelButton--nxtIs {
  color: #fc3633;
  background-color: #ffe5e0;
}
.style__selectControl--A8b7g .MuiSvgIcon-root {
  color: #26c1f3 !important;
}
.style__editRow--QJ_Wd {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}
.style__editActionButtons--Bglab {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}
.style__confirmButton--dg07K {
  flex-shrink: 0;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem !important;
  background-color: #c4ffcb !important;
  color: #00803e !important;
}
.style__confirmButton--dg07K:hover {
  background-color: #63ff94 !important;
}
.style__confirmButton--dg07K.Mui-disabled {
  background-color: #f1f2f4 !important;
  color: #afb2b6 !important;
}
.style__removeButton--MkY6V {
  flex-shrink: 0;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem !important;
  border: 1px solid #e3e4e8 !important;
  background-color: #fff !important;
  color: #7d8287 !important;
}
.style__removeButton--MkY6V:hover {
  background-color: #f9fafa !important;
}
.style__removeButton--MkY6V.Mui-disabled {
  color: #bdbfc2 !important;
  border-color: #f1f2f4 !important;
}
.style__addMoreWrapper--y9a9n {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 12px;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../components/src/UserLicenseManagement/style.less"],"names":[],"mappings":"AAKA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,2CAAA;EACA,aAAA;AAJF;AAOA;EACE,gBAAA;EACA,kBAAA;AALF;AAQA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;AANF;AASA;EACE,cAAA;EACA,cAAA;EACA,eAAA;AAPF;AAUA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;AARF;AAWA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AATF;AAYA;EACE,gBAAA;AAVF;AAaA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;AAXF;AAcA;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;AAZF;AAeA;EACE,eAAA;AAbF;AAgBA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;AAdF;AAWA;EAMI,aAAA;AAdJ;AAkBA;EACE,SAAA;AAhBF;AAmBA;EACE,cAAA;EACA,yBAAA;AAjBF;AAoBA;EAEI,yBAAA;AAnBJ;AAuBA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AArBF;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AAtBF;AAyBA;EACE,cAAA;EACA,aAAA;EACA,cAAA;EACA,gCAAA;EACA,oCAAA;EACA,yBAAA;AAvBF;AAyBE;EACE,oCAAA;AAvBJ;AA0BE;EACE,oCAAA;EACA,yBAAA;AAxBJ;AA4BA;EACE,cAAA;EACA,aAAA;EACA,cAAA;EACA,gCAAA;EACA,oCAAA;EACA,iCAAA;EACA,yBAAA;AA1BF;AA4BE;EACE,oCAAA;AA1BJ;AA6BE;EACE,yBAAA;EACA,gCAAA;AA3BJ;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AA7BF","sourcesContent":["@import '../colors';\n@import '../shadows';\n@import '../spacing';\n\n\n.contentBox {\n  display: flex;\n  flex-direction: column;\n  border-radius: 8px;\n  border: 1px solid rgba(125, 130, 135, 0.15);\n  padding: 16px;\n}\n\n.contentBoxTitle {\n  font-weight: 700;\n  font-style: normal;\n}\n\n.licenseChangeHint {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: @spacing-75;\n  margin: 0 0 @spacing-100 0;\n  padding: @spacing-75 @spacing-100;\n  background-color: @color-light-blue-099;\n  border: 1px solid @color-light-blue-095;\n  border-radius: 6px;\n  font-size: 0.8125rem;\n  color: @color-light-blue-040;\n  line-height: 1.4;\n}\n\n.licenseChangeHintIcon {\n  color: @color-light-blue-050;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  gap: @spacing-100;\n  width: 100%;\n  align-items: center;\n  padding: @spacing-100;\n}\n\n.licenseInfo {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n}\n\n.licenseCode {\n  font-weight: 600;\n}\n\n.licenseMeta {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: @spacing-50;\n  color: @color-asphalt-grey-050;\n  font-size: 0.8125rem;\n  flex-wrap: wrap;\n}\n\n.licenseSeparator {\n  color: @color-asphalt-grey-070;\n  font-size: 0.75rem;\n  user-select: none;\n}\n\n.badgeWrapper {\n  flex-basis: 10%;\n}\n\n.editButtonWrapper {\n  flex-basis: 20%;\n  display: flex;\n  flex-direction: row;\n\n  * {\n    margin: 0 2px;\n  }\n}\n\n.classDivider {\n  margin: 0;\n}\n\n.cancelButton {\n  color: @color-red-neon;\n  background-color: @color-red-095;\n}\n\n.selectControl {\n  :global(.MuiSvgIcon-root) {\n    color: @color-light-blue-070 !important;\n  }\n}\n\n.editRow {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: @spacing-75;\n  flex-wrap: wrap;\n}\n\n.editActionButtons {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: @spacing-50;\n  flex-shrink: 0;\n}\n\n.confirmButton {\n  flex-shrink: 0;\n  width: @spacing-250;\n  height: @spacing-250;\n  border-radius: @spacing-50 !important;\n  background-color: @color-green-095 !important;\n  color: @color-green-050 !important;\n\n  &:hover {\n    background-color: @color-green-090 !important;\n  }\n\n  &:global(.Mui-disabled) {\n    background-color: @color-asphalt-grey-095 !important;\n    color: @color-asphalt-grey-070 !important;\n  }\n}\n\n.removeButton {\n  flex-shrink: 0;\n  width: @spacing-250;\n  height: @spacing-250;\n  border-radius: @spacing-50 !important;\n  border: 1px solid @color-asphalt-grey-090 !important;\n  background-color: @color-white !important;\n  color: @color-asphalt-grey-050 !important;\n\n  &:hover {\n    background-color: @color-asphalt-grey-099 !important;\n  }\n\n  &:global(.Mui-disabled) {\n    color: @color-asphalt-grey-075 !important;\n    border-color: @color-asphalt-grey-095 !important;\n  }\n}\n\n.addMoreWrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin-top: 12px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentBox": `style__contentBox--ayMzs`,
	"contentBoxTitle": `style__contentBoxTitle--pRFJf`,
	"licenseChangeHint": `style__licenseChangeHint--JL57S`,
	"licenseChangeHintIcon": `style__licenseChangeHintIcon--9aUhJ`,
	"row": `style__row--y_Wbb`,
	"licenseInfo": `style__licenseInfo--CzpcN`,
	"licenseCode": `style__licenseCode--sfMwC`,
	"licenseMeta": `style__licenseMeta--LsWGh`,
	"licenseSeparator": `style__licenseSeparator--fcoel`,
	"badgeWrapper": `style__badgeWrapper--oFMl8`,
	"editButtonWrapper": `style__editButtonWrapper--GJq18`,
	"classDivider": `style__classDivider--QCIiF`,
	"cancelButton": `style__cancelButton--nxtIs`,
	"selectControl": `style__selectControl--A8b7g`,
	"editRow": `style__editRow--QJ_Wd`,
	"editActionButtons": `style__editActionButtons--Bglab`,
	"confirmButton": `style__confirmButton--dg07K`,
	"removeButton": `style__removeButton--MkY6V`,
	"addMoreWrapper": `style__addMoreWrapper--y9a9n`
};
export default ___CSS_LOADER_EXPORT___;
